import { Box, Fade, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'

import homeSplash from 'assets/svg/splash-logged_in.svg'
import LKQBackground from 'assets/svg/lkq-background.svg'

const LoggedInHome = () => {
  const { t } = useTranslation()
  const userName = useSelector((state: IRootReducerState) => `${state.auth.user.given_name}`)
  const greetings = ['support.home_page.greeting', 'support.home_page.greeting1', 'support.home_page.greeting2']

  const greetingIndex = Math.floor(Math.random() * greetings.length)
  const randomGreeting = greetings[greetingIndex]

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: theme => `calc(100vh - (75px + ${theme.spacing(2)}))`,
        margin: theme => theme.spacing(-1), // negative margin, root element has padding
        position: 'relative'
      }}
    >
      <Box
        sx={{
          zIndex: 2,
          position: 'absolute',
          width: theme => `calc(100% + ${theme.spacing(2)})`,
          height: theme => `calc(100% + ${theme.spacing(2)})`,
          backgroundImage: `url(${LKQBackground})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right',
          overflow: 'visible',
          backgroundSize: 'auto 100%',
          opacity: 0.3
        }}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          position: 'absolute',
          zIndex: 4,
          top: theme => theme.spacing(1),
          left: theme => theme.spacing(2)
        }}
      >
        <Typography
          variant='h4'
          sx={{
            fontWeight: 700,
            color: 'primary.main'
          }}
        >
          {t('support.home_page.title')}
        </Typography>
        <Box sx={{ height: 20, pl: 1.5, ml: 1.5, borderLeft: '2px solid rgba(0,0,0,.3)' }} />
        <Fade in timeout={1000}>
          <Typography variant='h5'>{t(randomGreeting, { name: userName })}</Typography>
        </Fade>
      </Box>

      <Box sx={{ display: 'block', width: '50%', height: 'auto', mb: 2, position: 'relative', zIndex: 3 }}>
        <Box component='img' src={homeSplash} alt='splash-home' />
      </Box>
    </Box>
  )
}

export default LoggedInHome
